import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { organizationTypeQueryLinkerSchema } from './organization-type-query-linker-schema';

export const organizationTypeQuerySchema = z.object({
  ...organizationTypeQueryLinkerSchema.shape,
  plural: z.string().nullable(),
  status: statusQuerySchema,
  clients_count: z.number(),
});

export type OrganizationTypeQuerySchema = z.infer<typeof organizationTypeQuerySchema>;

export const organizationTypeQueryAllSchema = paginatedResponseSchema(organizationTypeQuerySchema);
export type OrganizationTypeQueryAllSchema = z.infer<typeof organizationTypeQueryAllSchema>;
